import { useTranslation } from "react-i18next";
import React from "react";
import { Button } from "antd";
import moment from "moment";

interface PauseScreenProps {
  dateTimePause: number;
  timeDeadline?: number | string;
  onContinue?: (v?: any) => void;
}
function PauseScreen({ dateTimePause = 0 , onContinue }: PauseScreenProps) {
  const { t } = useTranslation();
  return (
    <div className="pause-screen">
      <div className="center flex-column content-center">
        <span className="font-weight-6 font-size-16 mb-1">
          {t("Bạn đang tạm dừng làm bài", "Bạn đang tạm dừng làm bài")}
        </span>
        <p className="font-size-16 font-weight-5">
          {t("Thời gian tạm dừng:", "Thời gian tạm dừng:")}{" "}
          <span className="text-primary">
            {moment(dateTimePause).format("HH:mm:ss - DD/MM/YYYY")}
          </span>
        </p>
        <p className="font-size-16 mt-1 font-weight-5">
          {t("Hạn nộp bài:", "Hạn nộp bài:")}{" "}
          <span className="text-primary">00:00:00 - 15/05/2024</span>
        </p>
      </div>
      <Button className="btn-primary h-40 mt-2 btn-start" onClick={onContinue}>
        {t("Tiếp tục", "Tiếp tục")}
      </Button>
    </div>
  );
}

export default PauseScreen;
